import { CloseIcon } from '@chakra-ui/icons';
import { IconButton, InputGroup, InputRightElement } from '@chakra-ui/react';
import {
  RangeDatepicker,
  RangeDatepickerProps,
} from 'chakra-dayzed-datepicker';
import { useCallback, useEffect, useState } from 'react';
import configs from './datepicker.config';

type CustomRangeDatepickerProps = Partial<RangeDatepickerProps> & {
  dates?: Date[];
};

export default function CustomRangeDatepicker({
  onDateChange,
  dates = [],
  ...props
}: CustomRangeDatepickerProps) {
  const [selectedDates, setSelectedDates] = useState<Date[]>(dates);

  useEffect(() => {
    setSelectedDates(dates);
  }, [dates]);

  const handleChangeDateFilter = useCallback(
    (dates: Date[]) => {
      setSelectedDates(dates);
      if (onDateChange) onDateChange(dates);
    },
    [onDateChange]
  );

  return (
    <InputGroup w="255px" pos="relative" zIndex={1}>
      <RangeDatepicker
        selectedDates={selectedDates}
        onDateChange={handleChangeDateFilter}
        triggerVariant="input"
        configs={configs}
        {...props}
      />
      {selectedDates.length > 0 && (
        <InputRightElement right="25px">
          <IconButton
            aria-label="Limpar"
            variant="ghost"
            icon={<CloseIcon boxSize="12px" />}
            onClick={() => handleChangeDateFilter([])}
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
}
